export default function createPoweredBy(props) {
    return (
        <div className="powered-by"><img src={require('../img/soluis-logo.png').default} alt="Soluis Logo"></img></div>
    )
}